import { memo, useMemo } from "react";
import Image from "next/image";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { styles } from "./icon_title_section";
import { useI18n } from "@/i18n/I18nProvider";

const PAGE_LOCALE_MAP = {
  shopping: "products_shopping_page",
  factoring: "products_factoring_page",
  leasing: "products_leasing_page",
};

function IconTileSection({ page = "shopping" }) {
  const { t } = useI18n();

  const pageLocale = PAGE_LOCALE_MAP[page] || PAGE_LOCALE_MAP.shopping;

  const items = useMemo(() => {
    return t?.general?.icon_title?.[pageLocale] || [];
  }, [t, pageLocale]);

  const shouldRemovePadding =
    page === "leasing" || page === "home-equity" || page === "mortgage";

  return (
    <Box
      component="section"
      sx={styles.sectionContainer}
      className={
        shouldRemovePadding
          ? ""
          : "horizontal-safe-padding vertical-safe-padding"
      }
    >
      <Grid container spacing={4}>
        {items.map((item, index) => {
          const isHidden = item.id == null;

          return (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
              key={`${pageLocale}-${item.id ?? index}`}
            >
              <Box
                data-aos="fade-up"
                sx={{
                  ...styles.container,
                  visibility: isHidden ? "hidden" : "visible",
                }}
                aria-hidden={isHidden}
              >
                <Box sx={styles.imgContainer}>
                  <Image
                    src={item.img}
                    width={50}
                    height={40}
                    alt={item.title || "icon"}
                    loading="lazy"
                    sizes="50px"
                    style={{
                      margin: "15px",
                      width: "50px",
                      height: "40px",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Box>
                  <Box component="h3" sx={styles.title()}>
                    {item.title}
                  </Box>

                  <Box sx={styles.description()}>
                    {item.sub_title}
                  </Box>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default memo(IconTileSection);